module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C153"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Interviews")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C185"
  }, [_vm._v("Note: For personal names, the spelling most commonly used or preferred by the individual in question is used. Chinese names usually appear in the order of last name followed by first name. For place names, the most commonly accepted form is used, usually the spelling preferred by the ROC government.")]), _vm._v(" "), _c('p', {
    staticClass: "C189"
  }, [_vm._v("List of Interviewees (in alphabetical order by surname), with Interview Location and Date")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Emile M. P. Chang, acting executive secretary, Investment Commission, Ministry of Economic Affairs; Taipei, June 27, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Chang Jung-feng, vice president, Chung-Hua Institution for Economic Research; former advisor, National Security Council; Taipei, June 18, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Morris Chang, CEO, Taiwan Semiconductor Manufacturing Co., Taipei, April 3, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Richard Chang, CEO, Semiconductor Manufacturing International Corp.; Shanghai, January 4, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Chang Sheng-han, member, National Taiwan University Labor Union; student participant in Wild Strawberry and Sunflower Movements; Taipei, June 28, 2014")])]), _c('p', {
    staticClass: "C196a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Chao Chien-min, deputy CEO, Foundation on International and Cross-Strait Studies; professor, Chengchi University; Taipei, August 17, 2006")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "C196a"
  }, [_vm._v("Henry Chen, chairman, MassMutual Mercuries Life Insurance; Taipei, July 12, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Sean Chen, chairman, Financial Supervisory Commission; Taipei, April 3, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Chiang Pin-kung, chairman, Straits Exchange Foundation; former head of Council for Economic Planning and Development; Taipei, April 9, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Chiu Chui-cheng, assistant professor, National Kinmen University; former staff member, Mainland Affairs Council; Taipei, June 18, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Fan Yun, professor, National Taiwan University; Taipei, April 2, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Fu Don-cheng, deputy minister, Mainland Affairs Council; Taipei, April 3, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Earle Ho, CEO, Tung-Ho Steel Enterprise; former chairman, Chinese National Federation of Industries; Taipei, April 2, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Ho Mei-yueh, former minister, Ministry of Economic Affairs; former chairwoman, Council for Economic Planning and Development; Taipei, July 30, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Paul S. P. Hsu, founding chairman, Epoch Foundation; Taipei, August 11, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Hsu Wen-fu (also known as Khou Bunhu), member and officer, Taiwan Association of University Professors and Taiwan Engineers Association; Taipei, July 29, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Hu Chung-ying, deputy minister, Council for Economic Planning and Development; Taipei, April 7, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Huang Shou-ta, member, National Taiwan University Labor Union; student participant in Wild Strawberry and Sunflower Movements; Taipei, June 28, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Huang Tien-lin, former national policy advisor to President Chen Shui-bian; Taipei, July 30, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Stan Hung, CEO, United Microelectronics Corp.; Taipei, April 3, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("King Pu-tsung, representative, Taipei Economic and Cultural Representative Office in the United States; former secretary-general, Kuomintang; Washington, DC, December 20, 2012")])]), _c('p', {
    staticClass: "C196a"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Edward Ku, general counsel, Yue Yuen Industrial Holdings; Hong Kong, November 29, 2007")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "C196a"
  }, [_vm._v("Kung Min-hsin, director, Taiwan Institute of Economic Research; Taipei, August 15, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Jimmy Lai, CEO, Next Media Group; Hong Kong, June 23, 2009 Lee Jin-yi, CEO, Fubon Bank (Hong Kong); Hong Kong, August 28, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Lin Yi-hsiung, former chairman, Democratic Progressive Party; Taipei, April 1, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Tsai Horng-ming, former senior advisor, National Security Council; former deputy secretary-general, Chinese National Federation of Industries; Taipei, July 31, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Robert Tsao, honorary chairman, United Microelectronics Corp.; Taipei, April 3, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Tseng Chao-yuan, CEO, Awakening Foundation; Taipei, April 2, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Tung Chen-yuan, former deputy minister, Mainland Affairs Council; Taipei, August 15, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Richard Vuylsteke, former chairman, American Chamber of Commerce in Taiwan; Hong Kong, May 26, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Gerald Warburg, former vice president, Cassidy & Associates; Charlottesville, VA, December 18, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Jaushieh Joseph Wu, secretary-general, Democratic Progressive Party; former chairman, Mainland Affairs Council; Taipei, June 27, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Wu Rong-i, chief executive, Taiwan Brain Trust; former president, Taiwan Institute of Economic Research; Taipei, October 25, 2011")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Yang Chao, chief editor, "), _c('em', [_vm._v("The Journalist")]), _vm._v("; Hong Kong, July 24, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Jeff Yang, director general, Bureau of Hong Kong Affairs, Mainland Affairs Council; Hong Kong, July 23, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Yang Yi-feng, director, National Teachers’ Association of the Republic of China; Taipei, June 17, 2008")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("Yen Cheung Kuang, director general, Taipei Economic and Cultural Office (Hong Kong); Hong Kong, June 19, 2014")]), _vm._v(" "), _c('p', {
    staticClass: "C196a"
  }, [_vm._v("You Mei-nu, legislator Democratic Progressive Party; Taipei, November 28, 2014")])]), _c('p', {
    staticClass: "C196a"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Yufu (pen name of Lin Kuei-you), former producer, TVBS and Sanlih Entertainment Television; political commentator; Taipei, April 1, 2009, and Hong Kong, July 19, 2014")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4fe62c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Interviews.vue
// module id = 75
// module chunks = 0